import { Category } from '@utilities/types/category.type';
import { FC, useCallback, useState } from 'react';

interface CategoryListProps {
    categories: Category[];
    onCategoryChange: (categoryId: string) => void;
    resetCategoryName: () => void
}

export const CategoryList: FC<CategoryListProps> = ({ categories, onCategoryChange, resetCategoryName }) => {
    const [currentCategory, setCurrentCategory] = useState<string | null>(null);

    const handleCategoryClick = useCallback((category: any) => {
        setCurrentCategory(category._id);
        onCategoryChange(category._id);
    }, [onCategoryChange]);

    return (
        <div className="h-screen overflow-y-auto flex flex-wrap gap-4 p-4 pb-28">
            <div
                className={`
                card w-60 h-20 bg-cover bg-center items-center justify-center
                text-white font-bold relative shadow-md rounded-md overflow-hidden
                ${!currentCategory ? 'bg-pink-400' : 'bg-gray-600'}
                `}
                onClick={() => {
                    setCurrentCategory(null)
                    onCategoryChange('')
                    resetCategoryName()
                }}>
                Tout
            </div>
            {categories.map((category, i) => (
                <div
                    key={i}
                    className={`
                        card w-60 h-20 bg-cover bg-center 
                        relative shadow-md rounded-md overflow-hidden 
                        ${currentCategory === category._id ? 'bg-pink-400' : 'bg-gray-600'}
                        `}
                    style={{
                        backgroundImage: `url(
                        ${currentCategory === category._id
                                ? ''
                                : process.env.REACT_APP_IMAGE_BASE_URL}/${category.images[0]
                                    .fileDir}/${category.images[0]
                                        .filename
                            }
                            )`
                    }}
                >
                    <button
                        onClick={() => handleCategoryClick(category)}
                        className={
                            `absolute inset-0 
                            flex items-center justify-center 
                            transition-all duration-300 bg-opacity-70 
                            ${currentCategory === category._id
                                ? 'bg-pink-500'
                                : 'bg-black'}`
                        }
                    >
                        <span className="text-white font-semibold text-sm truncate px-2">
                            {
                                category.name.length > 15
                                    ? `${category.name.slice(0, 15)}...`
                                    : category.name
                            }
                        </span>
                    </button>
                </div>
            ))}
        </div>
    );
};
